import P from '../pages';
import FormHeader from './FormHeader';
import Alert from './Alert';
import ReactMarkdown from 'react-markdown';
import { defaultMessages } from '../../../libs/i18n/default';
import FormControl from 'react-bootstrap/lib/FormControl';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import ReactHtmlParser from 'react-html-parser';
import { CustomFormGroup, Form, FormDate } from '../../../shared/components';
import React, { useState, useEffect, useRef } from 'react';
import { arrivalObj, pickupObj } from '../helpers'
import { useSelector } from 'react-redux';
import { pageValid, fieldsToValidate, validator } from '../../../shared/validator';
import { departureSubmit } from '../actions';
import withDefaults from './withDefaults'
import InlineButton from './InlineButton';
import { formatDate, optionsFromArray } from '../../../shared/utilities';
import { setProfileElementsFromState } from '../../../shared/profileElementHelpers';
import { get } from 'lodash';

const Departure = ({ content, dispatch, page, user, territory, intl: { formatMessage } }) => {
  const thisPage = P.DEPARTURE_PAGE;
  const [submitted, setSubmitted] = useState(false)
  const [timers, setTimers] = useState([])
  const { departure_pickup: gP, departure: gA } = user.guest
  const flightBooking = gA.departure_filename
  const [newUpload, setNewUpload] = useState(!gA.departure_filename)
  const delayedValidation = ['departurePlaceName']
  const timeOptions = useSelector(state => state.arrival_times)
  const contactTypes = ['Taxi', 'PublicTransport', 'FriendRelative', 'Rideshare', 'Other'].map(contactType => {
    let translationKey = 'clientGuestPagesDepartureSelectContactType'
    let key = translationKey + 'Keys' + contactType
    let value = translationKey + 'Values' + contactType

    return [defaultMessages[key].defaultMessage, defaultMessages[value].defaultMessage]
  })
  const transportTypeVal = () => {
    if (gP.transport_type) { return gP.transport_type }
    const apuRequired = setProfileElementsFromState('', 'placement', 'airport_pickup_required')
    if (apuRequired) { return apuRequired == 'Yes' ? 'transport_company' : 'other' }
    if (user.guest.type.code == 'high-school-student') { return 'transport_company' }
    return ''
  }
  const [fields, setFields] = useState({
    pickupDate: {
      ...pickupObj(gP, 'date'),
      errors: {
        greaterThanMaximum: formatMessage(defaultMessages.clientGuestPagesDeparturePopoversFutureDate)
      }
    },
    pickupTime: pickupObj(gP, 'time'),
    pickupTransportType: {
      ...pickupObj(gP, 'transport_type'),
      val: transportTypeVal()
    },
    pickupContactType: {
      ...pickupObj(gP, 'contact_type'),
      dependentObj: 'pickupTransportType',
      dependencyMet: (dependentObj = fieldsRef.current.pickupTransportType) => (dependentObj.val == 'other')
    },
    pickupContactName: {
      ...pickupObj(gP, 'contact_name'),
      dependentObj: 'pickupTransportType',
      dependencyMet: (dependentObj = fieldsRef.current.pickupTransportType) => (dependentObj.val == 'other')
    },
    pickupContactPhone: {
      ...pickupObj(gP, 'contact_phone'),
      dependentObj: 'pickupTransportType',
      dependencyMet: (dependentObj = fieldsRef.current.pickupTransportType) => (dependentObj.val == 'other')
    },
    pickupId: pickupObj(gP, 'id'),
    departureDate: {
      ...pickupObj(gA, 'date'),
      errors: {
        afterMaxDate: formatMessage(defaultMessages.clientGuestPagesArrivalPopoversMaxDate),
        greaterThanMaximum: formatMessage(defaultMessages.clientGuestPagesArrivalPopoversFutureDate)
      }
    },
    pickupNotes: pickupObj(gP, 'notes'),
    departureTime: arrivalObj(gA, 'time'),
    departureNotes: arrivalObj(gA, 'notes'),
    departureVesselNo: arrivalObj(gA, 'vessel_no'),
    departureId: arrivalObj(gA, 'id'),
    departurePlaceId: arrivalObj(gA, 'place_id'),
    departurePlaceName: arrivalObj(gA, 'place_name'),
    departureFlightBooking: { val: '' }
  })
  const [departurePlace, setDeparturePlace] = useState(fields.departurePlaceName.val)
  const debounceTimeout = useRef(null)
  const fieldsRef = useRef(fields)
  fieldsRef.current = fields

  const handleDepartureChange = (key, val) => {
    let timeout = delayedValidation.includes(key) && val ? 700 : 0
    let obj = fields[key]
    clearTimeout(timers[key])
    if (delayedValidation.includes(key)) {
      setFields(prevFields => ({...prevFields, [key]: {...obj, valid: null }}))
    }
    let timer = setTimeout(async() => {
      let result = await validator(val, obj.validationKey)
      obj.valid = get(result, 'valid')
      obj.failedValidation = get(result, 'failedValidation')
      obj.val = val
      obj.loading = false
      setFields(prevFields => ({...prevFields, [key]: obj}))
    }, timeout)
    setTimers({...timers, [key]: timer})
  }

  const autocompletePlace = (id, kind = '') => {
    $(id).autocomplete({
      source: `/places/autocomplete${kind}`,
      minLength: 2,
      autoFocus: true,
      delay: 100,
      select: function(e,ui){
        e.preventDefault();
        $(id).blur();
        handlePlaceSearch(ui.item)
      },
      focus: function(e,ui){
        e.preventDefault();
      }
    });
  }

  const handlePlace = (key, val) => {
    setDeparturePlace(val)

    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }

    debounceTimeout.current = setTimeout(() => {
      handleDepartureChange(key, val);
    }, 500);
  };


  useEffect(() => {
    autocompletePlace('#departurePlaceName', '?kind=airport, bus_terminal')

    fieldsToValidate(fields).forEach(async(f) => {
      handleDepartureChange(f, fields[f].val, false)
    })
  }, [])

  const handlePlaceSearch = async ({ label: name, value: id, query}) => {
    handlePlace('departurePlaceName', id == -1 ? query : name)
    handleDepartureChange('departurePlaceId', id == -1 ? '' : id)
  }

  const submit = (e) => {
    e.preventDefault()
    setSubmitted(true)
    dispatch(departureSubmit({...fields}))
  }

  return (
    <Form page={page} thisPage={thisPage} back={true} skip={true} submitFunc={submit} disableSubmit={!pageValid(fields) || submitted} >
      <FormHeader title={content.pages.departure.title} />
      <ReactMarkdown source={content.pages.departure.required_fields}/>
      <div className="row">
        <div className="col-md-6">
          <h5 style={{margin: 'auto'}}>{content.pages.departure.departure}</h5>
          <hr/>
          <CustomFormGroup field={fields.departurePlaceName}>
            <ControlLabel htmlFor="departurePlaceName">{formatMessage(defaultMessages.clientGuestPagesDepartureLabelsAirport)}</ControlLabel>
            <FormControl
              id="departurePlaceName"
              type="text"
              placeholder={formatMessage(defaultMessages.clientCommonSelectsSearch)}
              value={departurePlace}
              onChange={e => handlePlace('departurePlaceName', e.target.value)} />
          </CustomFormGroup>

          <CustomFormGroup field={fields.departureVesselNo}>
            <ControlLabel htmlFor="departureVesselNo">{formatMessage(defaultMessages.clientGuestPagesDepartureLabelsVessel)}</ControlLabel>
            <FormControl
              id="departureVesselNo"
              type="text"
              defaultValue={fields.departureVesselNo.val}
              onChange={e => handleDepartureChange('departureVesselNo', e.target.value)} />
          </CustomFormGroup>

          <CustomFormGroup field={fields.departureDate}>
            <ControlLabel htmlFor="departureDate_day">{formatMessage(defaultMessages.clientGuestPagesDepartureLabelsDepartureDate)}</ControlLabel>
            <FormDate
              setDate={date => handleDepartureChange('departureDate', date)}
              formDateId={'departureDate'}
              date={formatDate(fields.departureDate.val)} />
          </CustomFormGroup>

          <CustomFormGroup field={fields.departureTime}>
            <ControlLabel htmlFor="departureTime">{formatMessage(defaultMessages.clientGuestPagesDepartureLabelsDepartureTime)}</ControlLabel>
            <FormControl
              id="departureTime"
              type="select"
              componentClass="select"
              placeholder={formatMessage(defaultMessages.clientCommonSelectsSelect)}
              defaultValue={fields.departureTime.val}
              onChange={e => handleDepartureChange('departureTime', e.target.value)}>
              {optionsFromArray(timeOptions, formatMessage, 'departure')}
            </FormControl>
          </CustomFormGroup>

          <CustomFormGroup field={fields.departureNotes}>
            <ControlLabel htmlFor="departureNotes">{formatMessage(defaultMessages.clientGuestPagesDepartureLabelsDepartureNotes)}</ControlLabel>
            <FormControl
              id="departureNotes"
              type="text"
              componentClass="textarea"
              defaultValue={fields.departureNotes.val}
              onChange={e => handleDepartureChange('departureNotes', e.target.value)} />
          </CustomFormGroup>
          <div className="form-group">
            {flightBooking && (
              <p>
                {ReactHtmlParser(formatMessage(
                  defaultMessages.clientGuestPagesArrivalLabelsFileUploaded,
                  {name: flightBooking, kind: 'departure'}
                ))}
                {' '}
                <InlineButton type="button" onClick={() => setNewUpload(true)}>
                  {formatMessage(defaultMessages.clientGuestPagesArrivalLabelsReupload)}
                </InlineButton>
                {' '}
                {formatMessage(defaultMessages.clientGuestPagesArrivalLabelsReuploadSuffix)}
              </p>
            )}
            {newUpload && (
              <>
                <ControlLabel htmlFor="departure_flight_booking"> {formatMessage(defaultMessages.clientGuestPagesArrivalLabelsUploadFile)} </ControlLabel>
                <FormControl
                  id="departure_flight_booking"
                  data-testid="departure_flight_booking"
                  type="file"
                  componentClass="input"
                  onChange={e => setFields({...fieldsRef.current, departureFlightBooking: { val: e.target.files[0] }})}
                />
              </>
            )}
          </div>
        </div>

        <div className="col-md-6">
          <h5 style={{margin: 'auto'}}>{content.pages.departure.pickup}</h5>
          <hr/>

          <CustomFormGroup field={fields.pickupTransportType}>
            <ControlLabel htmlFor="pickupTransportType">{formatMessage(defaultMessages.clientGuestPagesDepartureLabelsRequirePickup)}</ControlLabel>
            <FormControl
              id="pickupTransportType"
              type="select"
              componentClass="select"
              placeholder={formatMessage(defaultMessages.clientCommonSelectsSelect)}
              defaultValue={content.territory_code == "asc" ? "transport_company" : fields.pickupTransportType.val}
              onChange={e => handleDepartureChange('pickupTransportType', e.target.value)}
              disabled={content.territory_code == "asc"}>
              <option value="" key="select">{formatMessage(defaultMessages.clientCommonSelectsSelect)}</option>
              <option value="transport_company" key="Yes">{formatMessage(defaultMessages.clientCommonAffirmative)}</option>
              <option value="other" key="No">{formatMessage(defaultMessages.clientCommonNegative)}</option>
            </FormControl>
          </CustomFormGroup>

          {fields.pickupTransportType.val == "other" &&
            <div>
              <ControlLabel htmlFor="pickupContactType">{formatMessage(defaultMessages.clientGuestPagesDepartureLabelsHow)}</ControlLabel>
              <CustomFormGroup field={fields.pickupContactType}>
                <FormControl
                  id="pickupContactType"
                  type="select"
                  componentClass="select"
                  placeholder={formatMessage(defaultMessages.clientCommonSelectsSelect)}
                  defaultValue={fields.pickupContactType.val}
                  onChange={e => handleDepartureChange('pickupContactType', e.target.value)}>
                  {optionsFromArray(contactTypes, formatMessage)}
                </FormControl>
              </CustomFormGroup>

              <CustomFormGroup field={fields.pickupContactName}>
                <FormControl
                  id="pickupContactName"
                  type="text"
                  componentClass="input"
                  placeholder={formatMessage(defaultMessages.clientGuestPagesDeparturePlaceholdersContactName)}
                  defaultValue={fields.pickupContactName.val}
                  onChange={e => handleDepartureChange('pickupContactName', e.target.value)} />
              </CustomFormGroup>

              <CustomFormGroup field={fields.pickupContactPhone}>
                <FormControl
                  id="pickupContactPhone"
                  type="text"
                  componentClass="input"
                  placeholder={formatMessage(defaultMessages.clientGuestPagesDeparturePlaceholdersContactPhone)}
                  defaultValue={fields.pickupContactPhone.val}
                  onChange={e => handleDepartureChange('pickupContactPhone', e.target.value)} />
              </CustomFormGroup>
            </div>
          }


          <CustomFormGroup field={fields.pickupDate}>
            <ControlLabel htmlFor="pickupDate_day">{formatMessage(defaultMessages.clientGuestPagesDepartureLabelsPickupDate)}</ControlLabel>
            <FormDate
              setDate={date => handleDepartureChange('pickupDate', date)}
              formDateId={'pickupDate'}
              date={formatDate(fields.pickupDate.val)} />
          </CustomFormGroup>

          <CustomFormGroup field={fields.pickupTime}>
            <ControlLabel htmlFor="pickupTime">{formatMessage(defaultMessages.clientGuestPagesDepartureLabelsPickupTime)}</ControlLabel>
            <FormControl
              id="pickupTime"
              type="select"
              componentClass="select"
              placeholder={formatMessage(defaultMessages.clientCommonSelectsSelect)}
              defaultValue={fields.pickupTime.val}
              onChange={e => handleDepartureChange('pickupTime', e.target.value)}>
              {optionsFromArray(timeOptions, formatMessage, 'pickup')}
            </FormControl>
          </CustomFormGroup>
          <CustomFormGroup field={fields.pickupNotes}>
            <ControlLabel htmlFor="pickupNotes">{formatMessage(defaultMessages.clientGuestPagesDepartureLabelsPickupNotes)}</ControlLabel>
            <FormControl
              id="pickupNotes"
              type="text"
              componentClass="textarea"
              defaultValue={fields.pickupNotes.val}
              onChange={e => handleDepartureChange('pickupNotes', e.target.value)} />
          </CustomFormGroup>
        </div>
      </div>
      <Alert alert={content.pages.departure.info}/>
    </Form>
  )
}

export default withDefaults(Departure);
